import { components, MenuListProps } from 'react-select';
import { CombinedSearchResult } from '../SearchBar.types';

export const CustomMenuList = (props: MenuListProps<CombinedSearchResult>): React.ReactElement => {
  const { children, options } = props;
  const resultCount = options.length;

  return (
    <components.MenuList
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(props as MenuListProps)}
    >
      {resultCount > 0 && (
        <p className="px-2 py-1 text-neutral-500 body-base">
          {resultCount} result{resultCount === 1 ? '' : 's'}
        </p>
      )}
      {children}
    </components.MenuList>
  );
};
